import app from 'flarum/forum/app';

/**
 * System events that are not shown in a discussion's feed (less/forum/discussion.less):
 * pinning / unpinning — the pin icon over the title already says it. The events stay in the
 * database and in core's stream (scrubber, scrolling); they are only not drawn.
 */
export const HIDDEN_EVENT_TYPES = ['discussionStickied'];

/** Numbers of the hidden events per discussion, fetched once (core's posts API, type filter). */
const fetched = new Map();
function hiddenNumbers(discussionId) {
  if (!fetched.has(discussionId)) {
    fetched.set(discussionId, null);
    Promise.all(HIDDEN_EVENT_TYPES.map(type => app.store.find('posts', {
      filter: {
        discussion: discussionId,
        type
      },
      page: {
        limit: 50
      }
    }))).then(lists => {
      fetched.set(discussionId, lists.flat().map(post => post.number()));
      m.redraw();
    }).catch(() => fetched.set(discussionId, []));
  }

  // plus any event that arrived in this session (e.g. pinned just now)
  const known = app.store.all('posts').filter(post => post.discussion()?.id() === discussionId && HIDDEN_EVENT_TYPES.includes(post.contentType())).map(post => post.number());
  return [...new Set([...(fetched.get(discussionId) || []), ...known])];
}

/** The number a reader sees: the post's own number without the hidden events before it (no gaps). */
export function visibleNumber(post) {
  const discussion = post.discussion();
  if (!discussion) return post.number();
  return post.number() - hiddenNumbers(discussion.id()).filter(n => n < post.number()).length;
}
flarum.reg.add('tarotportal-theme', 'forum/utils/postNumbers', { HIDDEN_EVENT_TYPES: HIDDEN_EVENT_TYPES,visibleNumber: visibleNumber, });